module.exports = __webpack_public_path__ + "img/mb_product_bg_small.74ca9eb.webp";